import ItemIcon from 'app/frontend/base/components/ItemIcon'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { wowheadUrl } from 'app/frontend/base/helpers'
import { EquippedItem } from 'app/frontend/types/custom'

const SocketIcon = ({
  socket,
}: {
  socket: EquippedItem['sockets'][number]
}) => {
  const {
    data: { gameVersion },
  } = usePageInfo()

  return (
    <span>
      {socket.gem ? (
        <a
          href={wowheadUrl(gameVersion, undefined, socket.gem)}
          target='_blank'
          rel='noreferrer'
        >
          <ItemIcon id={socket.gem} />
        </a>
      ) : socket.type ? (
        <img
          src={`https://data.wowaudit.com/img/socket-${socket.type.toLowerCase()}.gif`}
          className='w-5 h-5'
        />
      ) : null}
    </span>
  )
}

export default SocketIcon
